export default "__VITE_ASSET__CJ851hED__"